import { motion } from "framer-motion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { EmailComposer } from "@/components/admin/newsletter/EmailComposer";
import { SubscriberTable } from "@/components/admin/newsletter/SubscriberTable";
import { TemplateGrid } from "@/components/admin/newsletter/TemplateGrid";
import { EmailAnalytics } from "@/components/admin/newsletter/EmailAnalytics";

export default function Newsletter() {
  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }}>
        <h1 className="text-3xl font-semibold tracking-tight">Newsletter</h1>
        <p className="text-muted-foreground mt-1">
          Compose emails, manage subscribers, and track engagement.
        </p>
      </motion.div>

      <Tabs defaultValue="compose" className="space-y-6">
        <TabsList className="bg-secondary/50">
          <TabsTrigger value="compose">Compose</TabsTrigger>
          <TabsTrigger value="subscribers">Subscribers</TabsTrigger>
          <TabsTrigger value="templates">Templates</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>

        <TabsContent value="compose"><EmailComposer /></TabsContent>
        <TabsContent value="subscribers"><SubscriberTable /></TabsContent>
        <TabsContent value="templates"><TemplateGrid /></TabsContent>
        <TabsContent value="analytics"><EmailAnalytics /></TabsContent>
      </Tabs>
    </div>
  );
}
